// @mui
import { Button, InputAdornment, Stack, TextField } from '@mui/material';
// components
import Iconify from '../../components/iconify';
import { useLocales } from '../../locales';

// ----------------------------------------------------------------------

type Props = {
  filterName: string;
  isFiltered: boolean;
  onResetFilter: VoidFunction;
  onFilterName: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSearch: VoidFunction;
};

export default function GenericTableToolbar({
  isFiltered,
  filterName,
  onSearch,
  onFilterName,
  onResetFilter,
}: Props) {
  const { translate } = useLocales();
  return (
    <Stack
      spacing={2}
      alignItems="center"
      direction={{
        xs: 'column',
        sm: 'row',
      }}
      sx={{ px: 2.5, py: 3 }}
    >
      <TextField
        fullWidth
        value={filterName}
        onChange={onFilterName}
        onKeyUp={(key) =>
          key.code === 'Enter' || key.code === 'NumpadEnter' ? onSearch() : null
        }
        placeholder={`${translate('searchBar.search')}`}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled' }} />
            </InputAdornment>
          ),
        }}
      />

      {isFiltered && (
        <Button
          color="error"
          sx={{ flexShrink: 0 }}
          onClick={onResetFilter}
          startIcon={<Iconify icon="eva:trash-2-outline" />}
        >
          {`${translate('searchBar.clear')}`}
        </Button>
      )}

      <Button
        sx={{ flexShrink: 0 }}
        onClick={onSearch}
        startIcon={<Iconify icon="eva:search-fill" />}
      >
        {`${translate('searchBar.search')}`}
      </Button>
    </Stack>
  );
}
